import GlobalSettings from "lib/interfaces/globalsettings";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "views/App";

import "config/global";
import "styles/css/index.scss";

const root = ReactDOM.createRoot(document.getElementById("opusmap"));

root.render(<App />);